import Dashboard from 'screens/dashboard/Dashboard';
import IndividualView from 'screens/viewUser/ViewUser';
import UserDetails from 'screens/viewUser/UserDetails';
import DetailView from 'screens/viewUser/DetailView';
import Compare from 'screens/compare/Compare';
import Overlay from './screens/journal/Journal';
import Player from './screens/player/Player';
import Users from "./screens/users/Users";
import Test from "./screens/test"
import Team from "./screens/team/team"
import DummyDashboard from "screens/dummyDashboard/DummyDashboard";
import FourDashboard from 'screens/fourDashboard/FourDashboard';
import Reports from 'screens/Report/Reports';
export const routes = [
  {
    name: 'Dashboard',
    element: <Dashboard />,
    path: '/dashboard',
  },
  {
    name: 'Users',
    element: <Users />,
    path: '/users',
  },
  {
    name: 'DetailView',
    element: <DetailView />,
    path: '/detail-view',
  },
  {
    name: 'IndividualView',
    element: <IndividualView />,
    path: '/individualView',
  },
  {
    name: 'UserDetails',
    element: <UserDetails />,
    path: '/user-details',
  },
  {
    name: 'Compare',
    element: <Compare />,
    path: '/compare',
  },
  {
    name: 'Overlay',
    element: <Overlay />,
    path: '/juernal',
  },
  {
    name: 'Player',
    element: <Player />,
    path: '/patients',
  },

  {
    name: 'Reports',
    element: <Reports />,
    path: '/reports',
  },
  {
    name: 'test',
    element: <Test />,
    path: '/test',
  },
  {
    name: 'team',
    element: <Team />,
    path: '/team',
  },
  {
    name: 'DummyDashboard',
    element: <DummyDashboard />,
    path: '/dummy-dashbaord',
  },
  
  {
    name: 'FourDashboard',
    element: <FourDashboard />,
    path: '/four-dashboard',
  },
];
